import React, {useEffect} from "react";
import AnchorButton from "../../component/button/AnchorButton";
import path from "../../routes/path";
import {pageTitle} from "../../helper/CommonFunctions";
import { useTranslation } from 'react-i18next';
import './Error404.scss'
import ErrorImg from './img/ErrorImg.svg'
import {useNavigate} from "react-router-dom";


const Error404 = (props) => {
    pageTitle(props.pageTitle)
    const {t} = useTranslation();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return(
        <div className="error-404-page">
            <div className="container">
                <div className="row min-vh-100">
                    <div className="col-lg-10 offset-lg-1 align-self-center">
                        <div className="content">
                            <img src={ErrorImg} alt="ErrorImg" />
                            <h2>{t('error404.404')}</h2>
                            <p>{t('error404.content')}</p>
                            <AnchorButton
                                btnText={t('error404.back_to_home')}
                                to={`${process.env.PUBLIC_URL}${path.home}`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Error404;